import { AbstractControl, ValidatorFn } from '@angular/forms';

export class ZipCodeValidator {
    static unitedStates(control: AbstractControl): any {
        return ZipCodeValidator.validate('USA')(control);
    }

    static canada(control: AbstractControl): any {
        return ZipCodeValidator.validate('CAN')(control);
    }

    static other(control: AbstractControl): any {
        return ZipCodeValidator.validate('none')(control);
    }

    static validate(country: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control.value) {
                return null;
            }

            let pattern: RegExp;
            if (country === 'USA') {
                pattern = /^\d{5}(?:-\d{4})?$/;
            } else if (country === 'CAN') {
                pattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/; // Canadian postal code pattern
            } else {
                return null; // No validation for other countries
            }

            const valid = pattern.test(control.value);
            return valid ? null : { invalidZipCode: { value: control.value, ISO3: country } };
        };
    }
}
